export default "__VITE_ASSET__BUFCWOcP__"